import { useEffect, useState } from 'react';
import images from '../assets/images';
import ApprovalModal from '../components/modals/ApprovalModal';
import { useRequest } from '../hooks/useRequest';
import { useGeneralDispatch, useGeneralState } from '../context/general/generalContext';
import {
  APPROVAL_MODAL,
  EDIT_POST_MODAL,
  INTERESTS_MODAL,
  MY_POSTS
} from '../context/general/constants';
import EditPostModal from '../components/modals/EditPostModal';
import { InterestsModalWithImg } from '../components/modals/InterestsModalWithImg';
import {Link} from 'react-router-dom';
const Profile = () => {
  const { userInfo } = useGeneralState()
  const [interests, setInterests] = useState([]);
  const [page, setPage] = useState(3)
  const [hasNext, setHasNext] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const { request } = useRequest();
  const { approvalModal, editPostModal, interestsModal, myPosts } = useGeneralState();
  const dispatch = useGeneralDispatch();

  useEffect(() => {
    if (approvalModal.open == false && editPostModal.open == false) {
      request('post/getFeed', {
        method: 'POST',
        data: {
          getMyPost: true,
          categoryId: null,
          take: page,
          skip: 0
        }
      }).then((res) => {
        setHasNext(res.data.result.hasNextPage)
        setTotalCount(res.data.result.totalCount)
        dispatch({
          type: MY_POSTS,
          payload: res.data.result.items
        });
      });
    }
  }, [page,editPostModal,approvalModal]);
  useEffect(() => {
    if (interestsModal.open == false) {
      request('post/getUserInterestArea').then((res) => {
        setInterests(res.data.result);
      });
    }
  }, [interestsModal]);
  const openInterests = () => {
    dispatch({
      type: INTERESTS_MODAL,
      payload: {
        open: true,
        detail: interests,
        isFIrstLogin: false
      }
    });
  };
  const nextPage = () => {
    if (hasNext) {
      setPage(totalCount)
    }else {
      setPage(3)
    }
  }
  const openApproval = (detail) => {
    dispatch({
      type: APPROVAL_MODAL,
      payload: {
        open: true,
        detail: detail
      }
    });
  };
  const openEdit = (detail) => {
    dispatch({
      type: EDIT_POST_MODAL,
      payload: {
        open: true,
        detail: detail
      }
    });
  };
  return (
    <div className="container my-profile">
      {/* The Modal */}
      {approvalModal.open && <ApprovalModal />}
      {editPostModal.open && <EditPostModal />}
      {interestsModal.open && <InterestsModalWithImg />}
      {/* END the modal */}
      <h1 className="main-content--header">Profilim</h1>
      <div className="my-profile--card">
        <div className="profile-avatar">
          <img
            className="profile-avatar--preview"
            id="profile-avatar--preview"
            src={userInfo.photoUrl}
            alt="User Photo"
          />
        </div>
        <h2 className="my-profile--card--title">{userInfo.firstName} {userInfo.lastName}</h2>
        {/* <div className="my-profile--card--subtitle">Genel Müdür Yardımcısı</div> */}
      </div>
      <div className="my-profile--sub-area">
        <h3 className="my-profile--sub-area--title">İlgi Alanlarım</h3>
        <div className="my-profile--sub-area--card">
          {interests.length > 0 &&
            interests.map((interest) => (
              <div key={interest.id} className="my-profile--sub-area--card--interest-item">
                {interest.title}
              </div>
            ))}
          <button className="my-profile--sub-area--card--edit-btn" onClick={openInterests}>
            <img
              className="my-profile--sub-area--card--edit-btn--img"
              src={images.iconEdit}
              alt="Edit"
            />
            <span className="my-profile--sub-area--card--edit-btn--text">Düzenle</span>
          </button>
        </div>
      </div>
      <div className="my-profile--sub-area">
        <h3 className="my-profile--sub-area--title">Paylaşımlarım</h3>
        {myPosts?.length > 0 &&
          myPosts.map((post) => (
            <div key={post.id} className="my-profile--sub-area--card space-between padding-0">
              <div className="my-profile--sub-area--card--left">
                {
                  post?.resources[0]?.url.split('.').at(-1) == 'avi' ? 
                  <Link to={`/detail/${post.id}`}>
                  <video className="my-profile--sub-area--card--left--post-img">
                    <source src={post?.resources[0].url} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video></Link>
                  :
                <Link to={`/detail/${post.id}`}>
                <img
                  className="my-profile--sub-area--card--left--post-img"
                  src={post.resources[0]?.url ? post.resources[0].url : "http://93.180.132.116:15001/HeyAssets/noImage.png"}
                  alt="Post Image"
                />
                </Link>
                }
                <div className="my-profile--sub-area--card--left--post-detail">
                  <div className="my-profile--sub-area--card--left--post-detail--title">
                    {post.title}
                  </div>
                  <div className="my-profile--sub-area--card--left--post-detail--time">
                    <img
                      className="my-profile--sub-area--card--left--post-detail--time--img"
                      src={images.iconClock}
                      alt="Clock Icon"
                    />
                    <span className="my-profile--sub-area--card--left--post-detail--time--text">
                      {post.createdDate}
                    </span>
                  </div>
                  <div className="my-profile--sub-area--card--left--post-detail--interests">
                    {post.category.title}
                  </div>
                </div>
              </div>
              <div className="my-profile--sub-area--card--right">
                <div
                  className="my-profile--sub-area--card--right--delete"
                  onClick={() => openApproval(post)}>
                  <img
                    className="my-profile--sub-area--card--right--delete--img"
                    src={images.trash}
                    alt="Delete Icon"
                  />
                  <span className="my-profile--sub-area--card--right--delete--text">
                    Paylaşımı Sil
                  </span>
                </div>
                <div
                  className="my-profile--sub-area--card--right--edit"
                  data-modal-button="data-modal-button"
                  onClick={() => openEdit(post)}>
                  <img
                    className="my-profile--sub-area--card--right--edit--img"
                    src={images.iconEdit}
                    alt="Delete Icon"
                  />
                  <span className="my-profile--sub-area--card--right--edit--text">Düzenle</span>
                </div>
              </div>
            </div>
          ))}
          <button
            onClick={nextPage}
            className="my-profile--sub-area--see-all-btn">
            {hasNext ? 'Tüm Paylaşımlarımı Göster' : 'Daha Az Göster'}
          </button>
      </div>
    </div>
  );
};

export default Profile;
